import { z } from "zod";

/**
 * FolhaPagamentoSchema
 */

export const FolhaPagamentoSchema = z.object({
  descricao: z.string().nonempty({ message: 'É necessário preencher este campo!' }),
  dataCadastro: z.coerce.date({ required_error: 'É necessário preencher este campo!' }),
  dataPagamento: z.coerce.date({ required_error: 'É necessário preencher este campo!' }),
  tipo: z.number({ required_error: 'É necessário preencher este campo!' }),
});

/**
 * FolhaPagamentoForm
 */

export type FolhaPagamentoForm = z.infer<typeof FolhaPagamentoSchema>;

/**
 * initialFolhaPagamentoState
 */

export const initialFolhaPagamentoState: Partial<FolhaPagamentoForm> = {
  tipo: 0,
};